import PopupAbstract from 'pk/components/Popup/PopupAbstract'
import { markRaw } from 'vue'
import PopupPublish from './PopupPublish.vue'

export default class PopupPublishService extends PopupAbstract {
  public name = 'PopupPublishService'
  protected component = markRaw(PopupPublish)
}
